import "./style.scss";
import { Link } from "react-router-dom";
import bannerSliderMob from "@/src/assets/HomePage/BannerSlider/banner-slider-mob.png";
// import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";

const BannerSliderMob = () => {
  return (
    <div className="banner-slider-mob">
      <div className="banner-slider-mob-container container">
        <div className="banner-slider-mob-bg">
          <img src={bannerSliderMob} alt="Img" />
        </div>
        <div className="banner-slider-mob-content">
          <div className="banner-slider-mob-title">
            <p>Начни свой путь к европейскому диплому!</p>
          </div>
          <div className="banner-slider-mob-description">
            <p>Мальтийская школа медицины и бизнеса</p>
          </div>
          {/* <div className="banner-slider-mob-link">
            <ReadMoreBtn text={"Apply online →"} link={"/"} />
          </div> */}
        </div>
      </div>
      <div className="banner-slider-mob-buttons">
        {/* <Link to={"/"} className="btn-default reverse">
          Подобрать программу
        </Link> */}
        <Link to={"/apply-online"} className="btn-default reverse">
          Оставить заявку
        </Link>
      </div>
    </div>
  );
};
export default BannerSliderMob;
